export default __webpack_public_path__ + "static/media/obj3.4215e5ff.jpg";